import { Typography, Box, Button } from "@mui/material";
import { IConfigurableListItemProps } from "../types/api/permission";

export const ConfigurableListItem = ({
  title,
  color,
  id,
  onConfigure,
}: IConfigurableListItemProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        width: "100%",
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          flex: "1 1 auto",
          minWidth: 0,
          color: "#1f2937",
          bgcolor: color || "transparent",
          px: color ? 1.5 : 0,
          py: color ? 1.5 : 0,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </Typography>

      <Button
        variant="contained"
        onClick={() => onConfigure(id)}
        sx={{
          flex: "0 0 140px",
          width: 140,
          minWidth: 140,
          maxWidth: 140,
          height: 40,
          mr: 2.5,
          textTransform: "none",
          borderRadius: 1,
          bgcolor: "#FBBC05",
          color: "#fff",
          boxShadow: "none",
          "&:hover": {
            bgcolor: "#dea600",
            boxShadow: "none",
          },
        }}
      >
        Настроить
      </Button>
    </Box>
  );
};
